"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldValidateNode = exports.isReactNodeDOM = void 0;
var _ramda = require("ramda");
var isReactNodeDOM = exports.isReactNodeDOM = function isReactNodeDOM(nodeDOM) {
  return (0, _ramda.call)((0, _ramda.pipe)(_ramda.keys, (0, _ramda.any)((0, _ramda.startsWith)('__reactInternalInstance$'))), nodeDOM);
};
var getIsAvailableTagForInjection = function getIsAvailableTagForInjection(tag) {
  return (0, _ramda.includes)(tag, ['svg']);
};
var shouldValidateNode = exports.shouldValidateNode = function shouldValidateNode(nodeDOM) {
  var isElementNode = nodeDOM.nodeType === 1;
  var isAvailableTagForInjection = getIsAvailableTagForInjection(nodeDOM.tagName);
  return !isAvailableTagForInjection && isElementNode;
};